import Immutable from 'seamless-immutable';

export type Action = {
  type: string;
  payload?: any;
  status?: string;
  [key: string]: any;
};

// Cambiamos el tipo del estado a Immutable.Immutable<S>
export type ReducerHandler<S> = (state: Immutable.Immutable<S>, action: Action) => Immutable.Immutable<S>;

export type HandlersMap<S> = {
  [actionName: string]: ReducerHandler<S>;
};

/**
 * Helper to build a reducer
 */
export const createReducer = <S>(initialState: Immutable.Immutable<S>, handlers: HandlersMap<S>) => {
  return (state: Immutable.Immutable<S> = initialState, action: Action): Immutable.Immutable<S> => {
    const handler = handlers[action.type];
    // Forzamos un caspeo rápido para evitar que las firmas dinámicas de indexación fallen
    return handler ? (handler as any)(state, action) : state;
  };
};